import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../utils/utils';
import useLocalization from '../../../localization/useLocalization';

const SetInfinitySnoozeBase = styled.div<{ $isEnabled: boolean }>`
    color: ${colors.white.basic};
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin: 20px auto 0;
    cursor: pointer;
    padding: 6px 16px;
    user-select: none;
    pointer-events: ${props => (props.$isEnabled ? 'visible' : 'none')};
    &:hover {
        background-color: ${colors.blue.biscay};
    }
`;

interface SetInfinitySnoozeProps {
    onClick: () => void;
    isEnabled: boolean;
}

function SetInfinitySnooze(props: SetInfinitySnoozeProps) {
    const localization = useLocalization();
    return (
        <SetInfinitySnoozeBase onClick={props.onClick} $isEnabled={props.isEnabled}>
            {localization.getText('trainer.inactive.deactivate')}
        </SetInfinitySnoozeBase>
    );
}

export default SetInfinitySnooze;
